import { useTranslation } from 'react-i18next';
import { SuggestedFaqFieldsNames } from '../helpers';
import { useGetRequiredRule } from '@/hooks';

const useSuggestedFaqFormRules = () => {
  const { t } = useTranslation();
  const requiredRule = useGetRequiredRule({ t });

  return {
    [SuggestedFaqFieldsNames.QUESTION]: [requiredRule],
    [SuggestedFaqFieldsNames.ANSWER]: [requiredRule],
  };
};

export default useSuggestedFaqFormRules;
